{
  "_IMAGE_URL_BY_SKILL_ID": "Blockly/daten-und-inhalte/bausteine-und-variablen",
  "ADOBECONNECT_DISPATCHSYNCMESSAGE": "Blockly/integrationen/adobe-connect",
  "ADOBECONNECT_FUNCTIONS": "Blockly/integrationen/adobe-connect",
  "AITEXT_CHATCOMPLETION": "Blockly/ki-funktionen/ki-text",
  "AITEXT_STRUCTURED_RESPONSE": "Blockly/ki-funktionen/ki-text",
  "AITEXT_STRUCTURED_RESPONSE_FIELD": "Blockly/ki-funktionen/ki-text",
  "ALERT": "Blockly/logik-und-code/code",
  "AUDIO_doNotInterrupt": "Blockly/darstellung/bot-audio",
  "AUDIO_doNotInterruptCancel": "Blockly/darstellung/bot-audio",
  "AUDIO_initialMute": "Blockly/darstellung/bot-audio",
  "AUDIO_MIC_SETTING": "Blockly/darstellung/bot-audio",
  "AVATAR_addFooterButton": "Blockly/darstellung/bot-avatar",
  "AVATAR_BOT_SET": "Blockly/darstellung/bot-view",
  "AVATAR_CHAT_FOOTER": "Blockly/darstellung/bot-view",
  "AVATAR_CHAT_Header": "Blockly/darstellung/bot-view",
  "AVATAR_CHAT_UNSET": "Blockly/darstellung/bot-view",
  "AVATAR_clearFooterButtons": "Blockly/darstellung/bot-avatar",
  "AVATAR_doNotInterrupt": "Blockly/darstellung/bot-avatar",
  "AVATAR_doNotInterruptCancel": "Blockly/darstellung/bot-avatar",
  "AVATAR_setBGImg": "Blockly/darstellung/bot-avatar",
  "AVATAR_stop": "Blockly/darstellung/bot-avatar",
  "AVATAR_unsetBGImg": "Blockly/darstellung/bot-avatar",
  "AVATAR_USER_SET": "Blockly/darstellung/bot-view",
  "BEFORE_SEND_ABORT": "Blockly/start-und-ablauf/vor-dem-senden",
  "BEFORE_SEND_ABORT_IF": "Blockly/start-und-ablauf/vor-dem-senden",
  "BEFORE_SEND_ADD": "Blockly/start-und-ablauf/vor-dem-senden",
  "BEFORE_SEND_GET_MESSAGE": "Blockly/start-und-ablauf/vor-dem-senden",
  "BEFORE_SEND_SET_MESSAGE": "Blockly/start-und-ablauf/vor-dem-senden",
  "BLOCK_STACK_DOCUMENT": "Blockly/daten-und-inhalte/dokumente",
  "BLOCK_STACK_DOCUMENT_ALL": "Blockly/daten-und-inhalte/dokumente",
  "BLOCK_STACK_DOCUMENT_CONTENT": "Blockly/daten-und-inhalte/dokumente",
  "BLOCK_STACK_IMAGE": "Blockly/daten-und-inhalte/dokumente",
  "BLOCK_STACK_SKILL": "Blockly/start-und-ablauf/skills",
  "BLOCK_STACK_STAGE": "Blockly/start-und-ablauf/stages",
  "BOT_CONTROLS_ENDBOT": "Blockly/start-und-ablauf/steuerung",
  "BOT_CONTROLS_RESTART": "Blockly/start-und-ablauf/steuerung",
  "BOT_MODEL": "Blockly/start-und-ablauf/steuerung",
  "BOT_NAME": "Blockly/start-und-ablauf/steuerung",
  "BOT_TEMPERATURE": "Blockly/start-und-ablauf/steuerung",
  "BOTMESSAGE_BLOCK": "Blockly/chatinhalte-und-interaktionen/nachrichten-und-texte",
  "CALL_LATER": "Blockly/start-und-ablauf/ereignisse",
  "CARD_HTML": "Blockly/chatinhalte-und-interaktionen/mediainhalte",
  "CARD_IFRAME": "Blockly/chatinhalte-und-interaktionen/mediainhalte",
  "CARD_IMG_FROM_BLOCK_NEW": "Blockly/chatinhalte-und-interaktionen/mediainhalte",
  "CARD_VIMENO": "Blockly/chatinhalte-und-interaktionen/mediainhalte",
  "CARD_YOUTUBE": "Blockly/chatinhalte-und-interaktionen/mediainhalte",
  "CAST_TO_EVENT": "Blockly/start-und-ablauf/ereignisse",
  "CAST_TO_SKILL": "Blockly/start-und-ablauf/skills",
  "CAST_TO_STAGE": "Blockly/start-und-ablauf/stages",
  "CAST_TO_TEXT": "Blockly/chatinhalte-und-interaktionen/nachrichten-und-texte",
  "COMMENT": "Blockly/logik-und-code/aktionen-und-notizen",
  "CONFETTI": "Blockly/logik-und-code/extras",
  "CONFETTI_TEXT": "Blockly/logik-und-code/extras",
  "CONSOLE.log": "Blockly/logik-und-code/code",
  "CurrentStage_PROPERITES": "Blockly/start-und-ablauf/stages",
  "DEBUG_CARD": "Blockly/logik-und-code/code",
  "DEBUG_LOG_ENTRY": "Blockly/logik-und-code/code",
  "DEBUG_TOASTR": "Blockly/logik-und-code/code",
  "DIALOGRECORDER_start_NEW": "Blockly/daten-und-inhalte/dialog-recorder",
  "DOWNLOAD_FILLED_TEMPLATE": "Blockly/daten-und-inhalte/up-download",
  "DUMMY_BOOLEAN": "Blockly/daten-und-inhalte/bausteine-und-variablen",
  "DUMMY_NUMBER": "Blockly/daten-und-inhalte/bausteine-und-variablen",
  "DUMMY_STRING": "Blockly/chatinhalte-und-interaktionen/nachrichten-und-texte",
  "DUMMY_URL": "Blockly/daten-und-inhalte/bausteine-und-variablen",
  "EVENT_COLLECTION_CUSTOM": "Blockly/start-und-ablauf/ereignisse",
  "EVENT_DATA_OBJECT": "Blockly/start-und-ablauf/ereignisse",
  "EVENT_DATA_OBJECT_ATTRIBUTE": "Blockly/start-und-ablauf/ereignisse",
  "EVENT_DEBUG": "Blockly/start-und-ablauf/ereignisse",
  "EVENT_MANAGE": "Blockly/start-und-ablauf/ereignisse",
  "EVENT_TRIGGER_NEW": "Blockly/start-und-ablauf/ereignisse",
  "EVENTS_ON_NEW": "Blockly/start-und-ablauf/ereignisse",
  "EVENTS_ON_NEW_ONCE": "Blockly/start-und-ablauf/ereignisse",
  "EXPERT_AIIMAGE_FALAI_CREATE_OBJ": "Blockly-Expert/aiimage",
  "EXPERT_AIIMAGE_FALAI_GETURL_OBJ": "Blockly-Expert/aiimage",
  "EXPERT_AIIMAGE_OPENAI_ANALYZE_OBJ": "Blockly-Expert/aiimage",
  "EXPERT_AIIMAGE_OPENAI_CREATE_OBJ": "Blockly-Expert/aiimage",
  "EXPERT_AIIMAGE_OPENAI_GETURL_OBJ": "Blockly-Expert/aiimage",
  "EXPERT_AIIMAGE_SD_CREATE_OBJ": "Blockly-Expert/aiimage",
  "EXPERT_AIIMAGE_SD_GETURL_OBJ": "Blockly-Expert/aiimage",
  "EXPERT_AITEXT_OPENAI_CHAT_OBJ": "Blockly-Expert/aitext-openai",
  "EXPERT_AITEXT_OPENAI_CHATJSON_OBJ": "Blockly-Expert/aitext-openai",
  "EXPERT_AITEXT_OPENAI_STRUCTUREDRESPONSE_OBJ": "Blockly-Expert/aitext-openai",
  "EXPERT_AITEXT_VLLM_CHAT_OBJ": "Blockly-Expert/aitext-vllm",
  "EXPERT_AITEXT_VLLM_CHATJSON_OBJ": "Blockly-Expert/aitext-vllm",
  "EXPERT_AUDIO_BOTSAY_OBJ": "Blockly-Expert/audio",
  "EXPERT_AUDIO_GETINSTRUCTION": "Blockly-Expert/audio",
  "EXPERT_AUDIO_ISMICMUTED": "Blockly-Expert/audio",
  "EXPERT_AUDIO_MUTEMMIC": "Blockly-Expert/audio",
  "EXPERT_AUDIO_SAY_OBJ": "Blockly-Expert/audio",
  "EXPERT_AUDIO_SETINSTRUCTION_OBJ": "Blockly-Expert/audio",
  "EXPERT_AUDIO_SETTEXT_OBJ": "Blockly-Expert/audio",
  "EXPERT_AUDIO_STOPSPEAKING": "Blockly-Expert/audio",
  "EXPERT_AUDIO_UNMUTEMMIC": "Blockly-Expert/audio",
  "EXPERT_BEFORESEND_CLEAR": "Blockly-Expert/before-send",
  "EXPERT_BEFORESEND_LIST": "Blockly-Expert/before-send",
  "EXPERT_BOTAPI_CALLEXTERNAL_OBJ": "Blockly-Expert/botapi",
  "EXPERT_BOTAPI_GETFUNCTIONS": "Blockly-Expert/botapi",
  "EXPERT_BOTAPI_POSTMESSAGE_OBJ": "Blockly-Expert/botapi",
  "EXPERT_CARDS_ADDBOTCARD_OBJ": "Blockly-Expert/cards",
  "EXPERT_CARDS_HTML_OBJ": "Blockly-Expert/cards",
  "EXPERT_CARDS_IFRAME_OBJ": "Blockly-Expert/cards",
  "EXPERT_CARDS_IMAGE_OBJ": "Blockly-Expert/cards",
  "EXPERT_CARDS_LOADING_OBJ": "Blockly-Expert/cards",
  "EXPERT_CARDS_REMOVELOADING": "Blockly-Expert/cards",
  "EXPERT_CARDS_STAGELISTBUTTONS": "Blockly-Expert/cards",
  "EXPERT_CARDS_VIMEO_OBJ": "Blockly-Expert/cards",
  "EXPERT_CARDS_YOUTUBE_OBJ": "Blockly-Expert/cards",
  "EXPERT_CHATAVATAR_SETBOTIMG_OBJ": "Blockly-Expert/chat-avatar",
  "EXPERT_CHATAVATAR_SETUSERIMG_OBJ": "Blockly-Expert/chat-avatar",
  "EXPERT_CHATAVATAR_UNSETBOTIMG": "Blockly-Expert/chat-avatar",
  "EXPERT_CHATAVATAR_UNSETUSERIMG": "Blockly-Expert/chat-avatar",
  "EXPERT_DIALOGRECORDER_GETDIALOGHTML_OBJ": "Blockly-Expert/dialogrecorder",
  "EXPERT_DIALOGRECORDER_GETDIALOGJSON_OBJ": "Blockly-Expert/dialogrecorder",
  "EXPERT_DIALOGRECORDER_GETDIALOGTEXT_OBJ": "Blockly-Expert/dialogrecorder",
  "EXPERT_DIALOGRECORDER_INIT_OBJ": "Blockly-Expert/dialogrecorder",
  "EXPERT_DIALOGRECORDER_RECORD_OBJ": "Blockly-Expert/dialogrecorder",
  "EXPERT_DIALOGRECORDER_RESET_OBJ": "Blockly-Expert/dialogrecorder",
  "EXPERT_DIALOGRECORDER_STOP_OBJ": "Blockly-Expert/dialogrecorder",
  "EXPERT_DIALOGSTORE_GETCURRENT": "Blockly-Expert/dialogstore",
  "EXPERT_DIALOGSTORE_RESTORE_OBJ": "Blockly-Expert/dialogstore",
  "EXPERT_DIALOGSTORE_STORE_OBJ": "Blockly-Expert/dialogstore",
  "EXPERT_DOCSEARCH_SEARCHASCARD_OBJ": "Blockly-Expert/docsearch",
  "EXPERT_DOCSEARCH_SEARCHASJSON_OBJ": "Blockly-Expert/docsearch",
  "EXPERT_DOM_HIDEFOOTER": "Blockly-Expert/dom",
  "EXPERT_DOM_HIDEHEADER": "Blockly-Expert/dom",
  "EXPERT_DOM_LOADEXTERNALCSS_OBJ": "Blockly-Expert/dom",
  "EXPERT_DOM_LOADEXTERNALJS_OBJ": "Blockly-Expert/dom",
  "EXPERT_DOM_SETBODYCOLOR_OBJ": "Blockly-Expert/dom",
  "EXPERT_DOM_SHOWFOOTER": "Blockly-Expert/dom",
  "EXPERT_DOM_SHOWHEADER": "Blockly-Expert/dom",
  "EXPERT_DOM_STYLEVAR_OBJ": "Blockly-Expert/dom",
  "EXPERT_DOWNLOAD_FILLEDPDF_OBJ": "Blockly-Expert/download",
  "EXPERT_DOWNLOAD_GETMDCONTENT_OBJ": "Blockly-Expert/download",
  "EXPERT_DOWNLOAD_MATERIAL_OBJ": "Blockly-Expert/download",
  "EXPERT_DOWNLOAD_TEXTASFILE_OBJ": "Blockly-Expert/download",
  "EXPERT_EVENTS_INACTIVEHOOK_OBJ": "Blockly-Expert/events",
  "EXPERT_EVENTS_OFF_OBJ": "Blockly-Expert/events",
  "EXPERT_EVENTS_ON_OBJ": "Blockly-Expert/events",
  "EXPERT_EVENTS_TRIGGER_OBJ": "Blockly-Expert/events",
  "EXPERT_FUSIONVIEW_GOTO_OBJ": "Blockly-Expert/fusionview",
  "EXPERT_GROUPCHAT_DELETE": "Blockly-Expert/groupchat",
  "EXPERT_GROUPCHAT_READ": "Blockly-Expert/groupchat",
  "EXPERT_GROUPCHAT_SEND": "Blockly-Expert/groupchat",
  "EXPERT_HELPER_ADDSTAT_OBJ": "Blockly-Expert/helper",
  "EXPERT_HELPER_CLOSEWINDOW": "Blockly-Expert/helper",
  "EXPERT_HELPER_COPYTOCLIPBOARD_OBJ": "Blockly-Expert/helper",
  "EXPERT_HELPER_CURRENTLANGUAGE": "Blockly-Expert/helper",
  "EXPERT_HELPER_ENDBOT": "Blockly-Expert/helper",
  "EXPERT_HELPER_GETIMAGEURL_OBJ": "Blockly-Expert/helper",
  "EXPERT_INFO_MESSAGESCOUNT": "Blockly-Expert/info",
  "EXPERT_KEYVAL_DELETE_OBJ": "Blockly-Expert/keyval",
  "EXPERT_KEYVAL_GET_OBJ": "Blockly-Expert/keyval",
  "EXPERT_KEYVAL_GETBYTYPE_OBJ": "Blockly-Expert/keyval",
  "EXPERT_KEYVAL_SET_OBJ": "Blockly-Expert/keyval",
  "EXPERT_KEYVAL_UNIQUE_OBJ": "Blockly-Expert/keyval",
  "EXPERT_LOG_DISABLE": "Blockly-Expert/log",
  "EXPERT_LOG_ENABLE": "Blockly-Expert/log",
  "EXPERT_LOG_FILTER_OBJ": "Blockly-Expert/log",
  "EXPERT_MAIL_GETENVELOPE_OBJ": "Blockly-Expert/mail",
  "EXPERT_MAIL_SEND_OBJ": "Blockly-Expert/mail",
  "EXPERT_MAIL_WEBHOOK_OBJ": "Blockly-Expert/mail",
  "EXPERT_MSG_BOTBYPASS_OBJ": "Blockly-Expert/msg",
  "EXPERT_MSG_BOTMESSAGE_OBJ": "Blockly-Expert/msg",
  "EXPERT_MSG_OVERWRITESYSTEMPROMPT_OBJ": "Blockly-Expert/msg",
  "EXPERT_MSG_OVERWRITEWEBSEARCH_OBJ": "Blockly-Expert/msg",
  "EXPERT_MSG_PROMPT_OBJ": "Blockly-Expert/msg",
  "EXPERT_MSG_USERBYPASS_OBJ": "Blockly-Expert/msg",
  "EXPERT_MSG_USERMESSAGE_OBJ": "Blockly-Expert/msg",
  "EXPERT_OVERLAY_CLOSE": "Blockly-Expert/overlay",
  "EXPERT_OVERLAY_HTML_OBJ": "Blockly-Expert/overlay",
  "EXPERT_OVERLAY_LOADING_OBJ": "Blockly-Expert/overlay",
  "EXPERT_OVERLAY_PROMPT_GETINPUTVALUE": "Blockly-Expert/overlay",
  "EXPERT_OVERLAY_SETPLACEMENT_OBJ": "Blockly-Expert/overlay",
  "EXPERT_OVERLAY_TEXT_OBJ": "Blockly-Expert/overlay",
  "EXPERT_PARENT_EXEC_OBJ": "Blockly-Expert/parent",
  "EXPERT_PARENT_GET_OBJ": "Blockly-Expert/parent",
  "EXPERT_PROJECTKEYVAL_DELETE_OBJ": "Blockly-Expert/projectkeyval",
  "EXPERT_PROJECTKEYVAL_GET_OBJ": "Blockly-Expert/projectkeyval",
  "EXPERT_PROJECTKEYVAL_GETBYTYPE_OBJ": "Blockly-Expert/projectkeyval",
  "EXPERT_PROJECTKEYVAL_SET_OBJ": "Blockly-Expert/projectkeyval",
  "EXPERT_PROJECTKEYVAL_UNIQUE_OBJ": "Blockly-Expert/projectkeyval",
  "EXPERT_QUIZ_ANSWERED": "Blockly-Expert/quiz",
  "EXPERT_QUIZ_ASKED": "Blockly-Expert/quiz",
  "EXPERT_QUIZ_CLEANUP": "Blockly-Expert/quiz",
  "EXPERT_QUIZ_END": "Blockly-Expert/quiz",
  "EXPERT_QUIZ_ISRUNNING": "Blockly-Expert/quiz",
  "EXPERT_QUIZ_NEXTQUESTION": "Blockly-Expert/quiz",
  "EXPERT_QUIZ_STARTFROMTEXT_OBJ": "Blockly-Expert/quiz",
  "EXPERT_SCORE_ACHIEVE_OBJ": "Blockly-Expert/score",
  "EXPERT_SCORE_ADD_OBJ": "Blockly-Expert/score",
  "EXPERT_SCORE_DB_OBJ": "Blockly-Expert/score",
  "EXPERT_SCORE_GET": "Blockly-Expert/score",
  "EXPERT_SCORE_RESET": "Blockly-Expert/score",
  "EXPERT_SCORE_SET_OBJ": "Blockly-Expert/score",
  "EXPERT_SCORE_SUB_OBJ": "Blockly-Expert/score",
  "EXPERT_SCORM_COMMIT": "Blockly-Expert/scorm",
  "EXPERT_SCORM_FINISH": "Blockly-Expert/scorm",
  "EXPERT_SCORM_GET_OBJ": "Blockly-Expert/scorm",
  "EXPERT_SCORM_INIT": "Blockly-Expert/scorm",
  "EXPERT_SCORM_ISINIT": "Blockly-Expert/scorm",
  "EXPERT_SCORM_SET_OBJ": "Blockly-Expert/scorm",
  "EXPERT_SKILL_DISABLEALL": "Blockly-Expert/skill",
  "EXPERT_SKILL_DISABLEANDCHILDREN_OBJ": "Blockly-Expert/skill",
  "EXPERT_SKILL_DISABLESKILLS_OBJ": "Blockly-Expert/skill",
  "EXPERT_SKILL_ENABLEANDCHILDREN_OBJ": "Blockly-Expert/skill",
  "EXPERT_SKILL_ENABLESKILLS_OBJ": "Blockly-Expert/skill",
  "EXPERT_SKILL_FORNEXTRUN_OBJ": "Blockly-Expert/skill",
  "EXPERT_SKILL_GETSKILLS": "Blockly-Expert/skill",
  "EXPERT_SKILL_UNFORCEALL": "Blockly-Expert/skill",
  "EXPERT_STAGE_ADD_OBJ": "Blockly-Expert/stage",
  "EXPERT_STAGE_GOTOINDEX_OBJ": "Blockly-Expert/stage",
  "EXPERT_STAGE_GOTONAME_OBJ": "Blockly-Expert/stage",
  "EXPERT_STAGE_GOTORANDOM_OBJ": "Blockly-Expert/stage",
  "EXPERT_STAGE_HIDE_OBJ": "Blockly-Expert/stage",
  "EXPERT_STAGE_LIST_OBJ": "Blockly-Expert/stage",
  "EXPERT_STAGE_NEXT": "Blockly-Expert/stage",
  "EXPERT_STAGE_PREV": "Blockly-Expert/stage",
  "EXPERT_STAGE_REMOVE_OBJ": "Blockly-Expert/stage",
  "EXPERT_STAGE_RESTORE": "Blockly-Expert/stage",
  "EXPERT_STAGE_SHOW_OBJ": "Blockly-Expert/stage",
  "EXPERT_SUPERVISOR_GETINFO_OBJ": "Blockly-Expert/supervisor",
  "EXPERT_SUPERVISOR_NOTIFY_OBJ": "Blockly-Expert/supervisor",
  "EXPERT_SUPERVISOR_SETINFO_OBJ": "Blockly-Expert/supervisor",
  "EXPERT_VIDEOAVATAR_GETBG": "Blockly-Expert/video-avatar",
  "EXPERT_VIDEOAVATAR_SETBG_OBJ": "Blockly-Expert/video-avatar",
  "EXPERT_VIDEOAVATAR_SETTEXT_OBJ": "Blockly-Expert/video-avatar",
  "EXPERT_VIDEOAVATAR_UNSETIMG": "Blockly-Expert/video-avatar",
  "EXPERT_VIMEO_PAUSE": "Blockly-Expert/vimeo",
  "EXPERT_VIMEO_PLAY": "Blockly-Expert/vimeo",
  "EXPERT_VIMEO_POSITION": "Blockly-Expert/vimeo",
  "EXPERT_VIMEO_SEEKTO_OBJ": "Blockly-Expert/vimeo",
  "EXPERT_VIMEO_SETRATE_OBJ": "Blockly-Expert/vimeo",
  "EXPERT_VIMEO_SETVOLUME_OBJ": "Blockly-Expert/vimeo",
  "EXPERT_WAITFOR_EVENT_OBJ": "Blockly-Expert/waitfor",
  "EXPERT_WAITFOR_INITIALIDLE": "Blockly-Expert/waitfor",
  "EXPERT_WAITFOR_MINUTES_OBJ": "Blockly-Expert/waitfor",
  "EXPERT_WAITFOR_NEXTIDLE": "Blockly-Expert/waitfor",
  "EXPERT_WAITFOR_SECONDS_OBJ": "Blockly-Expert/waitfor",
  "EXPERT_WAITFOR_VARSINIT": "Blockly-Expert/waitfor",
  "EXPERT_WEBHOOK_CALL_OBJ": "Blockly-Expert/webhook",
  "EXPERT_YOUTUBE_LOADVIDEO_OBJ": "Blockly-Expert/youtube",
  "EXPERT_YOUTUBE_MUTE": "Blockly-Expert/youtube",
  "EXPERT_YOUTUBE_PAUSE": "Blockly-Expert/youtube",
  "EXPERT_YOUTUBE_PLAY": "Blockly-Expert/youtube",
  "EXPERT_YOUTUBE_SEEKTO_OBJ": "Blockly-Expert/youtube",
  "EXPERT_YOUTUBE_SETRATE_OBJ": "Blockly-Expert/youtube",
  "EXPERT_YOUTUBE_SETVOLUME_OBJ": "Blockly-Expert/youtube",
  "EXPERT_YOUTUBE_STOP": "Blockly-Expert/youtube",
  "EXPERT_YOUTUBE_UNMUTE": "Blockly-Expert/youtube",
  "FV_BOT_BTN_VISIBILITY": "Blockly/darstellung/fusion-view",
  "FV_BOT_VISIBILITY": "Blockly/darstellung/fusion-view",
  "FV_VIEW_SWITCH": "Blockly/darstellung/fusion-view",
  "GROUP": "Blockly/logik-und-code/aktionen-und-notizen",
  "GROUPCHAT_DELETE": "Blockly/ki-funktionen/bot-to-bot-nachricht",
  "GROUPCHAT_READ": "Blockly/ki-funktionen/bot-to-bot-nachricht",
  "GROUPCHAT_SEND": "Blockly/ki-funktionen/bot-to-bot-nachricht",
  "HELPER_ADDSTAT": "Blockly/logik-und-code/helfer",
  "HTML_TAG": "Blockly/daten-und-inhalte/bausteine-und-variablen",
  "INFO_MESSAGECOUNT": "Blockly/start-und-ablauf/steuerung",
  "JSON_GET_PROPERTY": "Blockly/logik-und-code/code",
  "JSON_PARSE": "Blockly/logik-und-code/code",
  "JSON_STRINGIFY": "Blockly/logik-und-code/code",
  "KEYVAL_GET_COLLECTION_VALUES_V2": "Blockly/daten-und-inhalte/datenspeicher",
  "KEYVAL_GET_V2": "Blockly/daten-und-inhalte/datenspeicher",
  "KEYVAL_SET_V2": "Blockly/daten-und-inhalte/datenspeicher",
  "KEYVAL_UNIQUE_V2": "Blockly/daten-und-inhalte/datenspeicher",
  "LOAD_EXTERNAL_CSS_IN_BOT": "Blockly/logik-und-code/code",
  "LOAD_EXTERNAL_CSS_IN_FUSION": "Blockly/darstellung/fusion-view",
  "LOAD_EXTERNAL_JS_IN_BOT": "Blockly/logik-und-code/code",
  "LOAD_EXTERNAL_JS_IN_FUSION": "Blockly/darstellung/fusion-view",
  "LXT_ACTIONS": "Blockly/darstellung/fusion-lxt",
  "LXT_EVENTS": "Blockly/darstellung/fusion-lxt",
  "LXT_EVENTS_RAW": "Blockly/darstellung/fusion-lxt",
  "LXT_GO_TO_PAGE": "Blockly/darstellung/fusion-lxt",
  "LXT_PROPERTIES": "Blockly/darstellung/fusion-lxt",
  "MAIL_SEND_DIRECT": "Blockly/integrationen/mail",
  "MY_START_BLOCK": "Blockly/start-und-ablauf/steuerung",
  "OVERLAY_HTML": "Blockly/chatinhalte-und-interaktionen/overlays",
  "OVERLAY_LOADING": "Blockly/chatinhalte-und-interaktionen/overlays",
  "OVERLAY_UPLOAD_IMAGE_ANALYSE": "Blockly/ki-funktionen/ki-content",
  "OVERLAY_UPLOAD_TXT_ADVANCED": "Blockly/daten-und-inhalte/up-download",
  "OWN_FUNCTION_CALL": "Blockly/logik-und-code/aktionen-und-notizen",
  "OWN_FUNCTION_DEFINITION": "Blockly/logik-und-code/aktionen-und-notizen",
  "PARENT_CLOSE_BOT": "Blockly/integrationen/on-site-bot",
  "PARENT_EXEC": "Blockly/integrationen/on-site-bot",
  "PARENT_get": "Blockly/integrationen/on-site-bot",
  "PARENT_GET_TEXT": "Blockly/integrationen/on-site-bot",
  "PARENT_LOCATION_X": "Blockly/integrationen/on-site-bot",
  "PARENT_NAVIGATE_TO": "Blockly/integrationen/on-site-bot",
  "PARENT_OPEN_BOT": "Blockly/integrationen/on-site-bot",
  "PARENT_PARAM_BY_BAME": "Blockly/integrationen/on-site-bot",
  "PARENT_RECREATE_BOT_STATE": "Blockly/integrationen/on-site-bot",
  "QUIZ_ACTIONS": "Blockly/ki-funktionen/quiz",
  "QUIZ_ADDITIONAL_PROMPT_INFO": "Blockly/ki-funktionen/quiz",
  "QUIZ_ANSWER_DATA": "Blockly/ki-funktionen/quiz",
  "QUIZ_DEBUG_ALL": "Blockly/ki-funktionen/quiz",
  "QUIZ_GENERA_DATA": "Blockly/ki-funktionen/quiz",
  "QUIZ_HISTORY_CLEAR": "Blockly/ki-funktionen/quiz",
  "QUIZ_HISTORY_ENABLED": "Blockly/ki-funktionen/quiz",
  "QUIZ_HISTORY_LIMIT_SET": "Blockly/ki-funktionen/quiz",
  "QUIZ_START_FROM_TEXT": "Blockly/ki-funktionen/quiz",
  "QUIZ_START_FROM_TEXT_FREETEXT": "Blockly/ki-funktionen/quiz",
  "RAG_CONDITION": "Blockly/logik-und-code/bedingungen",
  "RAG_CONDITION_CHAT_HISTORY_EMPTY": "Blockly/start-und-ablauf/steuerung",
  "RAG_CONDITION_ENDSWITH": "Blockly/logik-und-code/bedingungen",
  "RAG_CONDITION_INCLUDES": "Blockly/logik-und-code/bedingungen",
  "RAG_CONDITION_NUM": "Blockly/logik-und-code/bedingungen",
  "RAG_CONDITION_STARTWITH": "Blockly/logik-und-code/bedingungen",
  "RAG_IF": "Blockly/start-und-ablauf/steuerung",
  "RAG_IF_ELSE": "Blockly/logik-und-code/bedingungen",
  "RAG_OPERATION_AND": "Blockly/logik-und-code/bedingungen",
  "RAG_OPERATION_NOT": "Blockly/logik-und-code/bedingungen",
  "RAG_OPERATION_OR": "Blockly/logik-und-code/bedingungen",
  "RAG_RAW": "Blockly/logik-und-code/code",
  "RAG_RAW_OUTPUT": "Blockly/logik-und-code/code",
  "RAGAI_DOWNLOAD": "Blockly/daten-und-inhalte/up-download",
  "RAGAI.HELPER.closeWindow": "Blockly/logik-und-code/helfer",
  "RAGAI.HELPER.copyToClipboard": "Blockly/logik-und-code/helfer",
  "RISE_ACTIONS": "Blockly/darstellung/fusion-rise",
  "RISE_EVENTS": "Blockly/darstellung/fusion-rise",
  "RISE_EVENTS_RAW": "Blockly/darstellung/fusion-rise",
  "RISE_GO_TO_PAGE": "Blockly/darstellung/fusion-rise",
  "RISE_PROPERTIES": "Blockly/darstellung/fusion-rise",
  "SCHEMA_FIELD_BOOLEAN": "Blockly/ki-funktionen/ki-text",
  "SCHEMA_FIELD_CRITERION": "Blockly/ki-funktionen/ki-text",
  "SCHEMA_FIELD_NUMBER": "Blockly/ki-funktionen/ki-text",
  "SCHEMA_FIELD_STRING": "Blockly/ki-funktionen/ki-text",
  "SCORE_ACHIEVE": "Blockly/integrationen/scores",
  "SCORE_ACHIVEMENTS": "Blockly/integrationen/scores",
  "SCORE_ADD": "Blockly/integrationen/scores",
  "SCORE_DB_ACHIEVE": "Blockly/integrationen/scores",
  "SCORE_DB_ACHIVEMENTS": "Blockly/integrationen/scores",
  "SCORE_DB_ADD": "Blockly/integrationen/scores",
  "SCORE_DB_GET": "Blockly/integrationen/scores",
  "SCORE_DB_RESET": "Blockly/integrationen/scores",
  "SCORE_DB_SET": "Blockly/integrationen/scores",
  "SCORE_DB_SUB": "Blockly/integrationen/scores",
  "SCORE_GET": "Blockly/integrationen/scores",
  "SCORE_INIT": "Blockly/integrationen/scores",
  "SCORE_RESET": "Blockly/integrationen/scores",
  "SCORE_SET": "Blockly/integrationen/scores",
  "SCORE_SUB": "Blockly/integrationen/scores",
  "SCORM_COMMIT": "Blockly/integrationen/scorm",
  "SCORM_FINISH": "Blockly/integrationen/scorm",
  "SCORM_GET": "Blockly/integrationen/scorm",
  "SCORM_INIT": "Blockly/integrationen/scorm",
  "SCORM_ISIINIT": "Blockly/integrationen/scorm",
  "SCORM_SET": "Blockly/integrationen/scorm",
  "SEND_PROMPT_TXT_NEW": "Blockly/chatinhalte-und-interaktionen/nachrichten-und-texte",
  "SEND_PROMPT_USER_BYPASS": "Blockly/chatinhalte-und-interaktionen/nachrichten-und-texte",
  "SEND_PROMPT_USERMESSAGE": "Blockly/chatinhalte-und-interaktionen/nachrichten-und-texte",
  "SKILL_COUNT_DISABLED": "Blockly/start-und-ablauf/skills",
  "SKILL_COUNT_ENABLED": "Blockly/start-und-ablauf/skills",
  "SKILL_COUNT_TOTAL": "Blockly/start-und-ablauf/skills",
  "SKILL_DISABLE": "Blockly/start-und-ablauf/skills",
  "SKILL_ENABLE": "Blockly/start-und-ablauf/skills",
  "STAGE_GOTO": "Blockly/start-und-ablauf/stages",
  "STAGE_LISTBTN": "Blockly/chatinhalte-und-interaktionen/nutzer-interaktion",
  "STAGE_OVERLAY": "Blockly/chatinhalte-und-interaktionen/overlays",
  "SWITCH_FUSION_VIEW": "Blockly/darstellung/fusion-view",
  "TEMPLATE_VALUE": "Blockly/daten-und-inhalte/up-download",
  "UPLOADFILE_PROPERITES": "Blockly/daten-und-inhalte/up-download",
  "VIMEO_ACTIONS": "Blockly/darstellung/fusion-vimeo",
  "VIMEO_EVENT_ON_TIME_HOOK": "Blockly/darstellung/fusion-vimeo",
  "VIMEO_EVENTS": "Blockly/darstellung/fusion-vimeo",
  "VIMEO_EVENTS_RAW": "Blockly/darstellung/fusion-vimeo",
  "VIMEO_GO_TO": "Blockly/darstellung/fusion-vimeo",
  "VIMEO_LOAD_VIDEO": "Blockly/darstellung/fusion-vimeo",
  "VIMEO_LOOP": "Blockly/darstellung/fusion-vimeo",
  "VIMEO_PROPERITES": "Blockly/darstellung/fusion-vimeo",
  "VIMEO_SPEED": "Blockly/darstellung/fusion-vimeo",
  "VIMEO_VOLUME": "Blockly/darstellung/fusion-vimeo",
  "WAITFOR_SECONDS_NEW": "Blockly/start-und-ablauf/steuerung",
  "WEBHOOK_CALL": "Blockly/integrationen/webhook",
  "YOUTUBE_ACTIONS": "Blockly/darstellung/fusion-youtube",
  "YOUTUBE_EVENT_ON_TIME_HOOK": "Blockly/darstellung/fusion-youtube",
  "YOUTUBE_EVENTS": "Blockly/darstellung/fusion-youtube",
  "YOUTUBE_EVENTS_RAW": "Blockly/darstellung/fusion-youtube",
  "YOUTUBE_GO_TO": "Blockly/darstellung/fusion-youtube",
  "YOUTUBE_LOAD_VIDEO": "Blockly/darstellung/fusion-youtube",
  "YOUTUBE_PROPERITES": "Blockly/darstellung/fusion-youtube",
  "YOUTUBE_SPEED": "Blockly/darstellung/fusion-youtube",
  "YOUTUBE_VOLUME": "Blockly/darstellung/fusion-youtube"
}
